import React from 'react'
import MainLayout from '../Layouts/Mainlayout'
import EditUserForm from './EditUserForm'
import { useParams } from 'react-router-dom'

const EditUser: React.FC = () => {

  const param = useParams();
  const {id} = param;
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <EditUserForm userId={id} />
      </MainLayout>
    </div>
  )
}

export default EditUser